import { useEffect, useState } from "react";
import { getPortadaURL } from "../utils/ConstantsURL";

export const useFetchPortadas = (
    token,
    refresh,
    idDocument,
) => {
    const [portadas, setPortadas] = useState([]);
    const [loadingPortadas, setLoadingPortadas] = useState(false);
  
    useEffect(() => {
      const fetchPortadas = async () => {
        setLoadingPortadas(true);
        try {
            const response = await fetch(
                getPortadaURL(idDocument),
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(
                    errorData.message || "Ocurrió un error al obtener las portadas."
                );
            }

            const data = await response.json();
            setPortadas(data.data);
            setLoadingPortadas(false);
        } catch (error) {
            setPortadas([]);
            setLoadingPortadas(false);
        }
    };

    fetchPortadas();

    }, [token, refresh, idDocument]);
    
    return { portadas, loadingPortadas };
};
